/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'addCircle': {
    width: 44,
    height: 44,
    viewBox: '0 0 44 44',
    data: '<path pid="0" d="M22 0C9.9 0 0 9.9 0 22s9.9 22 22 22 22-9.9 22-22S34.1 0 22 0zm8.8 24.2h-6.6v6.6c0 1.32-.88 2.2-2.2 2.2-1.32 0-2.2-.88-2.2-2.2v-6.6h-6.6c-1.32 0-2.2-.88-2.2-2.2 0-1.32.88-2.2 2.2-2.2h6.6v-6.6c0-1.32.88-2.2 2.2-2.2 1.32 0 2.2.88 2.2 2.2v6.6h6.6c1.32 0 2.2.88 2.2 2.2 0 1.32-.88 2.2-2.2 2.2z" _fill="#3D7FFF" fill-rule="nonzero"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/addCircle.js